/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";

async function start() {
  // Build-time injected env vars (baked in by build.ts define — works for S3 static hosting)
  (window as any).ENV = {
    EXPO_PUBLIC_USER_POOL_ID: process.env.EXPO_PUBLIC_USER_POOL_ID || "",
    EXPO_PUBLIC_COGNITO_ID: process.env.EXPO_PUBLIC_COGNITO_ID || "",
    EXPO_PUBLIC_COGNITO_DOMAIN: process.env.EXPO_PUBLIC_COGNITO_DOMAIN || "",
    EXPO_PUBLIC_USER_API_URL: process.env.EXPO_PUBLIC_USER_API_URL || "",
    EXPO_PUBLIC_MARKET_PRICE_API_URL: process.env.EXPO_PUBLIC_MARKET_PRICE_API_URL || "",
    EXPO_PUBLIC_OPERATION_API_URL: process.env.EXPO_PUBLIC_OPERATION_API_URL || "",
    EXPO_PUBLIC_ACCOUNT_API_URL: process.env.EXPO_PUBLIC_ACCOUNT_API_URL || "",
    EXPO_PUBLIC_GRAIN_API_URL: process.env.EXPO_PUBLIC_GRAIN_API_URL || "",
  };

  // In local dev, the Bun server exposes /api/config (reads .env at runtime).
  // In production (S3), this fetch fails silently and the baked-in values above are used.
  try {
    const res = await fetch("/api/config");
    if (res.ok) {
      (window as any).ENV = { ...(window as any).ENV, ...(await res.json()) };
    }
  } catch {
    console.warn("Could not load config from dev server, using build-time env vars.");
  }

  const { App } = await import("./App");
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
